export default "__VITE_ASSET__Bkk65JKz__"